import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { isTargetBlank } from './utils';
import { OV_EMS_CDN } from '../../config/theme';
import Button from '../Button';
import css from './Items.module.scss';
import UGC from '../UGC';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var animationLoops = [947, 788, 675, 675];
var sizes = [400, 600, 800, 1000, 1200];
export var CustomItem = function CustomItem(_ref) {
  var cta = _ref.cta,
      image = _ref.image,
      subtitle = _ref.subtitle,
      title = _ref.title,
      url = _ref.url;
  var targetBlank = {
    rel: 'noopener noreferrer',
    target: '_blank'
  };
  var linkProps = isTargetBlank(url) ? targetBlank : {};
  return /*#__PURE__*/_jsx("figure", {
    className: css.figure,
    children: /*#__PURE__*/_jsxs("a", _objectSpread(_objectSpread({
      className: css.link,
      href: url
    }, linkProps), {}, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: cc([css.item, css.hoverCtaItem]),
        children: [image && /*#__PURE__*/_jsx("div", {
          className: css.imageWrap,
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
            sizes: sizes,
            wrap: false
          }))
        }), cta && url && /*#__PURE__*/_jsxs("div", {
          className: css.cta,
          children: [animationLoops.map(function (height, idx) {
            return /*#__PURE__*/_jsx("div", {
              "aria-hidden": "true",
              className: cc([css.animationLoop, css.desktop]),
              role: "presentation",
              children: /*#__PURE__*/_jsx(Image, {
                alt: "A white circle",
                height: height,
                width: 1500,
                sizes: sizes,
                src: "".concat(OV_EMS_CDN, "media/swatches/circle").concat(idx + 1, "_white.png"),
                wrap: false
              })
            }, idx);
          }), /*#__PURE__*/_jsx(Button, {
            big: true,
            buttonIsh: true,
            white: true,
            children: cta
          })]
        })]
      }), /*#__PURE__*/_jsxs("figcaption", {
        className: css.figcaption,
        children: [subtitle && /*#__PURE__*/_jsx("h5", {
          className: css.subtitle,
          children: subtitle
        }), title && /*#__PURE__*/_jsx("h4", {
          className: css.title,
          children: title
        })]
      })]
    }))
  });
};
CustomItem.defaultProps = {
  cta: '',
  image: null,
  title: '',
  subtitle: '',
  url: ''
};
CustomItem.propTypes = {
  cta: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  title: PropTypes.string,
  url: PropTypes.string,
  subtitle: PropTypes.string
};
export var ProductItem = function ProductItem(_ref2) {
  var image = _ref2.image,
      imageHover = _ref2.imageHover,
      subtitle = _ref2.subtitle,
      title = _ref2.title,
      url = _ref2.url;
  return /*#__PURE__*/_jsx("figure", {
    className: css.figure,
    children: /*#__PURE__*/_jsxs("a", {
      className: css.link,
      href: url,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.imageWrap,
        children: /*#__PURE__*/_jsxs("div", {
          className: cc([css.item, css.productItem]),
          children: [image && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
            sizes: sizes,
            wrap: false
          })), imageHover && /*#__PURE__*/_jsx("div", {
            className: css.imageHover,
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, imageHover), {}, {
              sizes: sizes,
              wrap: false
            }))
          })]
        })
      }), /*#__PURE__*/_jsxs("figcaption", {
        className: css.figcaption,
        children: [title && /*#__PURE__*/_jsx("h4", {
          className: css.title,
          children: title
        }), subtitle && /*#__PURE__*/_jsx("h5", {
          className: css.subtitle,
          children: subtitle
        })]
      })]
    })
  });
};
ProductItem.defaultProps = {
  title: '',
  subtitle: ''
};
ProductItem.propTypes = {
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]).isRequired,
  imageHover: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  url: PropTypes.string.isRequired
};
export var UGCItem = function UGCItem(item) {
  return /*#__PURE__*/_jsx("div", {
    className: css.ugc,
    children: /*#__PURE__*/_jsx(UGC, _objectSpread({}, item))
  });
};